import styled from 'styled-components';

import { VerticalCenterBlock } from '../../../styled';

export const BlockWrapper = styled.div`
  margin-bottom: 24px;
`;

export const NotificationWrapper = styled(BlockWrapper)`
  width: 100%;
`;

export const ContentWrapper = styled(VerticalCenterBlock)`
  flex-direction: column;
`;

export const CardsWrapper = styled(ContentWrapper)`
  gap: 8px;
`;

export const NotificationLink = styled.a`
  color: ${(props) => props.theme.colors.brand};
  text-decoration: underline;
`;
